import moment from 'moment';

export const getPublishedRetiredCondition = (
  currentDate: moment.Moment,
  prefix?: string,
) => {
  const publishedDateTimeString = `${prefix || ''}published_datetime`;
  const retiredDateTimeString = `${prefix || ''}retired_datetime`;
  return {
    $or: [
      {
        [publishedDateTimeString]: null,
        [retiredDateTimeString]: null,
      },
      {
        [publishedDateTimeString]: {
          $lte: currentDate.format('YYYY-MM-DD 00:00:00'),
        },
        [retiredDateTimeString]: null,
      },
      {
        [publishedDateTimeString]: null,
        [retiredDateTimeString]: {
          $gte: currentDate.format('YYYY-MM-DD 00:00:00'),
        },
      },
      {
        [publishedDateTimeString]: {
          $lte: currentDate.format('YYYY-MM-DD 00:00:00'),
        },
        [retiredDateTimeString]: {
          $gte: currentDate.format('YYYY-MM-DD 00:00:00'),
        },
      },
    ],
  };
};

export const getNotDeletedOrNullCondition = (property: string) => {
  return {
    $or: [
      {
        [`${property}._is_deleted`]: false,
      },
      {
        [`${property}._is_deleted`]: null,
      },
    ],
  };
};
